module.exports = __webpack_public_path__ + "static/graphik-medium-7c87a43083d1e306db77df5db082fea9.woff";